module.exports = new __parcel__URL__("puppy2.6c084030.png").toString();